import { ReactElement } from 'react';
import { IntlConfig } from 'gatsby-plugin-react-intl';

type ObjectType = { [key: string]: string };

type AnalyticsType = {
  eventName: string;
  linkProps?: ObjectType,
}

type LinkRefType = {
  current: any;
}

type ProspectusLinkPropType = {
  allowFragment?: boolean;
  analytics: AnalyticsType;
  href: string;
  children: ReactElement;
  className?: string;
  intl: IntlConfig;
  linkProps?: ObjectType;
  linkRef?: LinkRefType;
  tracking?: ObjectType;
  userLanguage?: string | boolean;
  displayUrlAsIs?: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick?: (e) => void;
  isTrackLink: boolean;
  onTrackingAdded?: () => void;
  allowWebviewLinksForEdxDomain?:boolean; // See comments in https://2u-internal.atlassian.net/browse/SEO-1269
}

const ProspectusLinkDefaultProps = {
  allowFragment: false,
  className: '',
  linkProps: {},
  linkRef: undefined,
  tracking: {},
  userLanguage: false,
  displayUrlAsIs: false,
  onClick: null,
  onTrackingAdded: null,
  isTrackLink: true,
};

export { ProspectusLinkDefaultProps, ProspectusLinkPropType };
